import { render, staticRenderFns } from "./react-modify.vue?vue&type=template&id=4a04e144&scoped=true&"
import script from "./react-modify.vue?vue&type=script&lang=js&"
export * from "./react-modify.vue?vue&type=script&lang=js&"
import style0 from "./react-modify.vue?vue&type=style&index=0&id=4a04e144&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a04e144",
  null
  
)

export default component.exports